import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { AuthGuardGuard } from './auth-guard.guard';
import { StorageService } from '../storage/storage.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private _authService: AuthService,
    private storageService: StorageService,
     private _router: Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // return next.handle(request);

    // Clone the request object
    let newReq = request.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if (request.url !== 'https://backend1.growwsaas.com/file-uploader/userService/verifyotp') {
      if (this.storageService.accessToken) {
        newReq = request.clone({
          headers: request.headers.set('Authorization', 'Bearer ' + this.storageService.accessToken)
        });
      }
    }
    // Response
    return next.handle(newReq).pipe(
      catchError((error) => {

        console.log(error)
        // Catch "401 Unauthorized" responses
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Sign out
          this._authService.signOut();

          // Reload the app
          // location.reload();
          // Redirect to login page instead of reloading
          this._router.navigate(['/login']);
          
        }

        return throwError(error);
      })
    );

  }
}
